import { HttpErrorResponse, HttpEvent, HttpHandlerFn, HttpRequest } from '@angular/common/http';
import { Router } from '@angular/router';
import { inject } from '@angular/core';
import { NGXLogger } from 'ngx-logger';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { BYPASS_ERROR_HANDLING, BypassMode } from './error-bypass';
import { BackendErrorType, parseBackendErrorResponse } from './backend.errors';

export function errorInterceptor(req: HttpRequest<unknown>, next: HttpHandlerFn): Observable<HttpEvent<unknown>> {
  const router = inject(Router);
  const logger = inject(NGXLogger);

  return next(req).pipe(catchError((error: HttpErrorResponse) => httpErrorHandler(router, logger, req, error)));
}

function httpErrorHandler(
  router: Router,
  logger: NGXLogger,
  request: HttpRequest<unknown>,
  response: HttpErrorResponse,
) {
  logger.error(response);
  const backendErrorType = parseBackendErrorResponse(response);

  if (isBypassed(request, response)) {
    return throwError(() => new Error(backendErrorType));
  }

  // Central handling for server errors: call sites only bypass 4xx codes they classify and handle
  // locally (see error-bypass.ts's BypassMode.CLIENT_ERRORS), so every 5xx reaches this branch
  // and is redirected here instead of at each call site.
  if (backendErrorType === BackendErrorType.SERVER_ERROR) {
    router.navigate(['error']);
  }

  return throwError(() => new Error(backendErrorType));
}

function isBypassed(request: HttpRequest<unknown>, response: HttpErrorResponse): boolean {
  const mode = request.context.get(BYPASS_ERROR_HANDLING);
  return mode === BypassMode.CLIENT_ERRORS && response.status >= 400 && response.status < 500;
}
